import { render, staticRenderFns } from "./bill-index.vue?vue&type=template&id=03a5b4eb&"
import script from "./bill-index.vue?vue&type=script&lang=js&"
export * from "./bill-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports